export const URL_Alerts = (`${process.env.REACT_APP_HOST}/alerts`)
export const URL_AlertClinic = (`${process.env.REACT_APP_HOST}/alertsClinic`)